export const variableAlwaysNumber = (variable: number | string): number => (typeof variable === "string" ? parseInt(variable) : variable);
